var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 3,
    height: 3,
    fill: "#6F7171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayBoxes);
export default __webpack_public_path__ + "static/media/gray-boxes.d60b3a03d44721383497b3c66d99657c.svg";
export { ForwardRef as ReactComponent };